<template>
  <div class="page">
    <div class="main-container">
      <div class="content">
        <div class="content-topic">
          <el-collapse v-model="activeNames">
            <span v-for="(items, idx) in authQuestion" :key="idx">
              <el-collapse-item :title="(idx+1) + '.' + items.title">
                <div v-html="formatContent(items.content)"  @click="handleContentClick"></div>
              </el-collapse-item>
            </span>
          </el-collapse>
        </div>
      </div>
    </div>
    <Service/>
  </div>
</template>

<script>
import Service from "./Service";
import axios from 'axios';
export default {
  name: 'Index',
  components: {Service},

  data() {
    return {
      activeNames: '',
      authQuestion: [],
      gender: 2,
      imAction : {
        1:['做任务', 'toDayTask'],
        2:['每日任务', 'toDayTask'],
        3:['贵族','toVip'],
        4: ['贵族特享', 'toVip'],
        5:['真人认证', 'toRealPerson'],
        6:['金币清单', 'toGoldBill'],
        7:['积分清单', 'toIntegralBill'],
        8:['收费设置', 'toMoneySetting'],
        9:['上传头像', 'toAvatar'],
        10:['在线客服', 'toCustomer'],
        11:['消费记录', 'toIntegralBill'],
        12:['积分兑换', 'toIntegral'],
        13:['陌生约聊平台用户行为规范', 'userAgent'],
        14:['编辑语音签名', 'toVoiceFlag'],
        15:['温馨提示:同一台设备仅限每日签到一次，超出次数当日不可再次签到。', 'toSign']
      }
    }
  },
  created() {
    this.gender  = this.getQueryParam('gender') === null ? 2 : parseInt(this.getQueryParam('gender'));
  },
  mounted() {
    axios.get(process.env.BASE_API + '/feedback', {'params':{'type':2, 'gender': this.gender}})
      .then(res => {
        if (res.data) {
          this.authQuestion = res.data.data[2]
        }
      })
      .catch(err => {
        console.error('请求feedback接口失败:', err);
      });
  },
  method: function () {
    window.showInfoFromJs = this.showInfoFromJs
  },
  methods: {
    formatContent(content) {
      if (!content) return '';
      return content.replace(/(做任务|每日任务|贵族|贵族特享|真人认证|金币清单|积分清单|收费设置|上传头像|在线客服|消费记录|积分兑换|陌生约聊平台用户行为规范|编辑语音签名|温馨提示:同一台设备仅限每日签到一次，超出次数当日不可再次签到。)/g, match => {
        return `<span class="highlight-action" style="color:cornflowerblue;cursor:pointer;">${match}</span>`;
      });
    },

    handleContentClick(e) {
      if (e.target.classList.contains('highlight-action')) {
        const text = e.target.innerText;
        switch (text) {
          case this.imAction[1][0]:
            this.handleSpanClick(this.imAction[1][1])
            break;
          case this.imAction[2][0]:
            this.handleSpanClick(this.imAction[2][1])
            break;
          case this.imAction[3][0]:
            this.handleSpanClick(this.imAction[3][1])
            break;
          case this.imAction[4][0]:
            this.handleSpanClick(this.imAction[4][1])
            break;
          case this.imAction[5][0]:
            this.handleSpanClick(this.imAction[5][1])
            break;
          case this.imAction[6][0]:
            this.handleSpanClick(this.imAction[6][1])
            break;
          case this.imAction[7][0]:
            this.handleSpanClick(this.imAction[7][1])
            break;
          case this.imAction[8][0]:
            this.handleSpanClick(this.imAction[8][1])
            break;
          case this.imAction[9][0]:
            this.handleSpanClick(this.imAction[9][1])
            break;
          case this.imAction[10][0]:
            this.handleSpanClick(this.imAction[10][1])
            break;
          case this.imAction[11][0]:
            this.handleSpanClick(this.imAction[11][1])
            break;
          case this.imAction[12][0]:
            this.handleSpanClick(this.imAction[12][1])
            break;
          case this.imAction[13][0]:
            this.handleSpanClick(this.imAction[13][1])
            break;
          case this.imAction[14][0]:
            this.handleSpanClick(this.imAction[14][1])
            break;
          case this.imAction[15][0]:
            this.handleSpanClick(this.imAction[15][1])
            break;
          default:
          // execute default code block
        }
      }
    },
    goAddPage(route) {
      this.$router.push(route);
    },
    handleSpanClick(value) {
      var basePath = "<%=basePath%>";
      var browser = {
        versions: function () {
          var u = navigator.userAgent, app = navigator.appVersion;
          return {//移动终端浏览器版本信息
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
            iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('iPad') > -1, //是否iPad
          };
        }(),
        language: (navigator.browserLanguage || navigator.language).toLowerCase()
      };

      // 调用浏览器版本信息判断是IOS还是Android
      if (browser.versions.ios || browser.versions.iPhone || browser.versions.iPad) {
        window.webkit.messageHandlers.WebToiOS.postMessage(value);
      } else {
        this.showInfoFromJs(value);
      }
    },
    webToAndroid(value) {
      var basePath = "<%=basePath%>";
      var browser = {
        versions: function () {
          var u = navigator.userAgent, app = navigator.appVersion;
          return {//移动终端浏览器版本信息
            ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
            android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
            iPhone: u.indexOf('iPhone') > -1 || u.indexOf('Mac') > -1, //是否为iPhone或者QQHD浏览器
            iPad: u.indexOf('iPad') > -1, //是否iPad
          };
        }(),
        language: (navigator.browserLanguage || navigator.language).toLowerCase()
      }

      //调用浏览器版本信息判断是IOS还是Android
      if (browser.versions.ios || browser.versions.iPhone || browser.versions.iPad) {
        window.webkit.messageHandlers.WebToiOS.postMessage(value);
      } else {
        this.showInfoFromJs(value)
      }
    },
    showInfoFromJs(value) {
      return window.AndroidWebView.showInfoFromJs(value);
    },
    getQueryParam(param) {
      const query = window.location.search.substring(1);
      const vars = query.split('&');

      for (const item of vars) {
        const [key, value] = item.split('=');
        if (decodeURIComponent(key) === param) {
          return decodeURIComponent(value);
        }
      }
      return null;
    },
  }
}
</script>


<style scoped>

.icon-top {
  width: 100%;
  height: 143px;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
}

.icon-item {
  width: 80px;
  height: 102px;
  border-radius: 8px;
}

.hr {
  height: 12px;
  width: 100%;
  background: #F9FAFC;
}


.content {
  width: 100%;
}

.content-title {
  margin-top: 20px;
  margin-left: 12px;
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 600;
}


/deep/ .van-cell {
  color: #666666;
}

/deep/ .van-icon-circle2 {
  color:#3576F9;
}

/deep/ .van-icon-circle {
  color: #E6E5E5;
}

/deep/ .checked-title {
  font-size: 15px;
  color: #000000 !important;
}
/deep/ .unchecked {
  font-size: 15px;
}

.item-content {
  font-size: 13px;
  color: #333333;
  line-height: 20px;
  padding-left: 20px;
  padding-right: 20px;
}

.item-title {
  font-weight: 600;
}

.key-text{
  font-weight: 500;
  color: #4C30FC;
}

.item-img{
  width: 100%;
  text-align: center;
  margin-top: 30px;
}

/*.page {
  background-image: url("../assets/img/bg.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}*/
.customer-service {
  position: fixed;
  bottom: 30px;
  left: 80%;
  transform: translateX(-50%);
  width: 60px;
  height: 60px;
}

.customer-service img {
  width: 100%;
  height: 100%;
}

.red-text {
  color: red;
}

.blue-text {
  color: cornflowerblue;
}

.main-container{
  z-index: 999;
  position: relative;
  background-color: #f5f7fb;
  padding: 18px 18px 14px 18px;
}
.content .content-topic:last-child{
  margin-bottom: 70px;
}
.content-topic{
  padding: 0 13px;
  background-color: #ffffff;
  border-radius: 10px;
}
.content-topic .el-collapse {
  border-top: none;
  border-bottom: none;
}
.content-topic .el-collapse-item__header {
  font-size: 15px;
}
.content-topic .last .el-collapse-item__header {
  border-bottom: none;
}
</style>



// WEBPACK FOOTER //
// src/page/Certification.vue